<div class="pd-crumb">
  <a [routerLink]="['/mis-mascotas']">Mis mascotas</a>
  <span *ngIf="pet">&rsaquo; {{ pet.name }}</span>
</div>

<loading-indicator *ngIf="isLoading"></loading-indicator>

<div class="pd-vacio" *ngIf="!isLoading && !pet">
  <p>No encontramos esa mascota.</p>
  <a class="pd-btn" [routerLink]="['/mis-mascotas']">Volver a Mis mascotas</a>
</div>

<ng-container *ngIf="pet">

  <header class="pd-top">
    <img class="pd-foto" [src]="getImage()" (error)="loadErrorImage($event)" [alt]="pet.name || 'Mascota'">
    <div class="pd-ident">
      <h1>{{ pet.name }}</h1>
      <p class="pd-sub">{{ pet.breed?.name || 'Sin raza indicada' }}</p>
      <div class="pd-acts">
        <a class="pd-btn" [routerLink]="['/edit-pet', pet.id]">Editar sus datos</a>
        <!-- El formulario de edicion ya incluye la carga de foto (sube a S3),
             asi que este atajo va al mismo lugar. Solo aparece cuando no hay
             foto: con foto cargada serian dos botones al mismo destino. -->
        <a class="pd-btn gh" *ngIf="!pet.pictureUrl" [routerLink]="['/edit-pet', pet.id]">Subir su foto</a>
      </div>
    </div>
  </header>

  <section class="mc-blk">
    <div class="mc-hd"><h2>Sus datos</h2></div>
    <div class="pd-datos">
      <a class="pd-fila" *ngFor="let f of cargados" [routerLink]="['/edit-pet', pet.id]">
        <span class="pd-dot"></span>
        <span class="pd-k">{{ f.clave }}</span>
        <span class="pd-v">{{ f.valor }}</span>
        <span class="pd-c">Editar &rsaquo;</span>
      </a>
    </div>
  </section>

  <!-- Lo que falta va acá, con el motivo al lado, y no como filas "Falta" en la
       lista de arriba. Y en una mascota con todo cargado el bloque no aparece:
       no insistir es parte del diseño. -->
  <section class="mc-blk" *ngIf="faltantes.length">
    <div class="mc-hd"><h2>Contanos un poco más de {{ pet.name }}</h2></div>

    <div class="pd-medidor">
      <div class="pd-medidor-top">
        <b>Su perfil está a medio completar</b>
        <span>{{ cargados.length }} de {{ filas.length }}</span>
      </div>
      <div class="pd-barra"><i [style.width.%]="progreso"></i></div>
    </div>

    <a class="pd-sug" *ngFor="let f of faltantes" [routerLink]="['/edit-pet', pet.id]">
      <span class="pd-sug-t">
        <b>{{ f.clave }}</b>
        <span>{{ f.motivo }}</span>
      </span>
      <span class="pd-c">Agregar &rsaquo;</span>
    </a>
  </section>

  <!-- ─────────── Etapa 2 ─────────── -->

  <!-- Próximos controles: recordatorios que carga la veterinaria. -->
  <section class="mc-blk" *ngIf="tieneRecordatorios">
    <div class="mc-hd"><h2>Lo que viene</h2></div>
    <div class="pd-card">
      <div class="pd-vac proxima" *ngFor="let r of historia!.recordatorios">
        <span class="pd-vdot"></span>
        <span class="pd-vt">
          <b>{{ r.descripcion }}</b>
          <span>{{ r.fecha | date:'d \'de\' MMMM \'de\' y':'':'es-AR' }}</span>
        </span>
      </div>
    </div>
  </section>

  <section class="mc-blk">
    <div class="mc-hd">
      <h2>Historia clínica</h2>
      <span class="pd-tag ok" *ngIf="tieneHistoria">Datos de la veterinaria Puppis</span>
    </div>

    <loading-indicator *ngIf="cargandoHistoria"></loading-indicator>

    <!-- Datos reales de la API de Vet: cada visita con fecha, motivo, peso,
         lugar y las vacunas o prácticas que se aplicaron. Los diagnósticos
         internos del profesional no se traen (ver pet-clinical.service.ts). -->
    <div class="pd-card" *ngIf="tieneHistoria">
      <div class="pd-vac" *ngFor="let v of historia!.visitas">
        <span class="pd-vdot"></span>
        <span class="pd-vt">
          <b>{{ v.motivo }}<span *ngIf="v.practicas.length" class="pd-vpract"> · {{ v.practicas.join(', ') }}</span></b>
          <span>
            {{ v.fecha | date:'d \'de\' MMMM \'de\' y':'':'es-AR' }}<ng-container *ngIf="v.lugar">, {{ v.lugar }}</ng-container><ng-container *ngIf="v.pesoKg"> · {{ v.pesoKg | number:'1.1-1':'es-AR' }} kg</ng-container>
          </span>
        </span>
      </div>
    </div>

    <!-- Sin historia clínica no es un error: es el caso más común, porque la
         mayoría de las mascotas no se atiende en nuestra veterinaria. -->
    <div class="pd-card pd-empty" *ngIf="!cargandoHistoria && !tieneHistoria">
      <h3>Todavía no tenemos la historia de {{ pet.name }}</h3>
      <p>Cuando lo atiendan en una veterinaria Puppis, acá vas a ver sus visitas y cuándo le toca cada vacuna.</p>
    </div>

    <p class="pd-nota" *ngIf="tieneHistoria">
      Esta ficha registra y recuerda. <b>No reemplaza una consulta veterinaria</b>
      y no indica tratamientos.
    </p>
  </section>

  <!-- Curva de peso real. Solo si hay dos o más mediciones: un punto no es
       curva, y con una sola medición se muestra el valor como texto. -->
  <section class="mc-blk" *ngIf="pesoActual != null">
    <div class="mc-hd">
      <h2>Peso</h2>
      <span class="pd-peso-hoy">{{ pesoActual | number:'1.1-1':'es-AR' }} kg</span>
    </div>

    <div class="pd-card" *ngIf="tieneCurva">
      <svg viewBox="0 0 640 150" class="pd-curva">
        <line x1="40" y1="120" x2="620" y2="120" stroke="#E4E7EC" stroke-width="1.5"/>
        <line x1="40" y1="75"  x2="620" y2="75"  stroke="#F0F2F5" stroke-width="1"/>
        <line x1="40" y1="30"  x2="620" y2="30"  stroke="#F0F2F5" stroke-width="1"/>
        <polyline [attr.points]="lineaCurva" fill="none" stroke="#3E71BE" stroke-width="2.5"
                  stroke-linecap="round" stroke-linejoin="round"/>
        <ng-container *ngFor="let p of puntosCurva">
          <circle [attr.cx]="p.x" [attr.cy]="p.y" [attr.r]="p.ultimo ? 6 : 4.5"
                  [attr.fill]="p.ultimo ? '#F9C43C' : '#16479D'"
                  [attr.stroke]="p.ultimo ? '#16479D' : 'none'" stroke-width="2.5"/>
          <text *ngIf="p.ultimo" [attr.x]="p.x" [attr.y]="p.y - 14" class="pd-curva-kg"
                text-anchor="middle">{{ p.kg | number:'1.1-1':'es-AR' }} kg</text>
          <text [attr.x]="p.x" y="140" class="pd-curva-eje" text-anchor="middle">{{ p.etiqueta }}</text>
        </ng-container>
      </svg>
    </div>
  </section>

  <section class="mc-blk">
    <div class="mc-hd"><h2>Otras acciones</h2></div>

    <!-- Ya registrada como fallecida: solo informativo. -->
    <div class="pd-accion off" *ngIf="pet.deceased">
      <span class="pd-sug-t">
        <b>{{ pet.name }} ya no está registrada con vos</b>
        <span>Su ficha y su historia quedan guardadas.</span>
      </span>
    </div>

    <!-- Accionable: pide confirmar el deceso. -->
    <button type="button" class="pd-accion pd-accion-btn"
            *ngIf="!pet.deceased && !confirmandoDeceso"
            (click)="pedirConfirmacionDeceso()">
      <span class="pd-sug-t">
        <b>{{ pet.name }} ya no está conmigo</b>
        <span>Dejamos de escribirte sobre {{ pet.name }}. Su ficha y su historia quedan guardadas.</span>
      </span>
      <span class="pd-c">&rsaquo;</span>
    </button>

    <!-- Confirmación inline. -->
    <div class="pd-accion pd-confirm" *ngIf="!pet.deceased && confirmandoDeceso">
      <span class="pd-sug-t">
        <b>¿Confirmás que {{ pet.name }} ya no está con vos?</b>
        <span>Actualizamos su ficha y dejamos de escribirte sobre {{ pet.name }}.</span>
      </span>
      <div class="pd-confirm-acc">
        <button type="button" class="pd-btn-ghost" (click)="cancelarDeceso()" [disabled]="guardandoDeceso">Cancelar</button>
        <button type="button" class="pd-btn-danger" (click)="confirmarDeceso()" [disabled]="guardandoDeceso">
          {{ guardandoDeceso ? 'Guardando…' : 'Sí, confirmar' }}
        </button>
      </div>
    </div>
  </section>

</ng-container>
